<template>
  <bj-modal
    v-model="visible"
    size="sm"
    :title="`Change ${business.name || business.owner_name} credits amount`"
  >
    <div slot="content">
      <div class="row gutter-sm">
        <div class="col-12">
          <q-radio
            v-model="payload.type"
            val="charge"
            label="Charge"
          />
          <q-radio
            v-model="payload.type"
            val="credit"
            label="Credit"
            class="q-ml-sm"
          />
        </div>
        <q-field
          icon="attach_money"
          :error="$v.payload.amount.$error"
          error-label="Amount must be greater than 1"
          class="col-12"
        >
          <q-input
            v-model="payload.amount"
            type="number"
            float-label="Amount"
          />
        </q-field>
        <q-field
          icon="comment"
          class="col-12"
        >
          <q-input
            v-model="payload.comment"
            type="text"
            float-label="Comment"
          />
        </q-field>
      </div>
      <bj-inner-loading
        label="Saving"
        :visible="loading"
      />
    </div>
    <div slot="footer">
      <q-btn-group
        rounded
        flat
      >
        <q-btn
          :disable="loading"
          rounded
          color="primary"
          icon="save"
          size="lg"
          outline
          label="Apply Credits"
          no-caps
          @click.prevent="submit"
        />
      </q-btn-group>
    </div>
  </bj-modal>
</template>

<script>
import { required, minValue } from 'vuelidate/lib/validators';

export default {
  name: 'SdChangeBusinessCreditsModal',
  validations() {
    return {
      payload: {
        amount: {
          required,
          minValue: minValue(1),
        },
        comment: {
          optional: true,
        },
      },
    };
  },
  data() {
    const basePayload = {
      amount: null,
      type: 'charge',
      comment: null,
    };

    return {
      visible: false,
      loading: false,
      basePayload,
      payload: this.clone(basePayload),
      business: {},
    };
  },
  methods: {
    show(business) {
      this.visible = true;
      this.loading = false;
      this.payload = this.clone(this.basePayload);
      this.business = business;
      this.$v.$reset();
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.loading = true;

      const payload = {
        amount: this.payload.type === 'charge' ? this.payload.amount : -this.payload.amount,
        comment: this.payload.comment,
      };
      const url = `admin/businesses/${this.business.id}/balance-transactions`;

      try {
        await this.api().request('POST', url, payload);
      } catch (response) {
        this.uiNotify(this.getFirstError(response) || response.message || 'Error occurred', 'negative');
        this.loading = false;
        return;
      }

      this.$emit('success');
      this.loading = false;
      this.visible = false;

      const message = `${this.payload.type === 'charge' ? 'Charged' : 'Credited'} successfully`;

      this.uiNotify(message);
    },
  },
};
</script>
